import script from "./NotificationWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&setup=true&lang=js"

import "./NotificationWidget.vue?vue&type=style&index=0&id=c9eae63a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9eae63a"]])

export default __exports__